import { render, staticRenderFns } from "./team_team_management.vue?vue&type=template&id=18dd21d9&"
import script from "./team_team_management.vue?vue&type=script&lang=js&"
export * from "./team_team_management.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports